import { useLanguageData } from '@/common/hooks/useLanguageData';
import SynthiAiLogo from '@/common/images/Logo.svg';
import {
	ActionWrapper,
	SynthiAiLogoWrapper,
	Wrapper,
	WrapperRest,
} from './OnePageFastSpringPaymentV3.styles';
import Plan from './components/plan/Plan';
import useMakeOnePageFastSpringPaymentV3 from './hook/useMakeOnePageFastSpringPaymentV3';
import Loading from '@/common/components/Loading';

const OnePageFastSpringPaymentV3 = () => {
	const translations = useLanguageData('checkout');
	const { isLoading, promo, selectedOption } =
		useMakeOnePageFastSpringPaymentV3();

	return (
		<>
			{isLoading && <Loading />}
			<Wrapper>
				<SynthiAiLogoWrapper>
					<img src={SynthiAiLogo} />
				</SynthiAiLogoWrapper>
				<Plan promo={promo} selectedOption={selectedOption} />
				<ActionWrapper>
					<div id='fsc-embedded-checkout-container' autoFocus />
				</ActionWrapper>
			</Wrapper>
		</>
	);
};

export default OnePageFastSpringPaymentV3;
